import React from 'react';
import LoadingOverlay from 'react-loading-overlay';
const OverLay=(props)=>{
    return(
        <LoadingOverlay
            active={props.active}
            spinner
            text='Wait...'
            styles={{
                wrapper:(base)=>({
                    ...base,
                    position:'inherit'
                })
            }}
            >
        </LoadingOverlay>
    )
}
export default OverLay;